module.exports = __webpack_public_path__ + "img/01-menu-bar-on_02.a31f16f7.png";